import React from "react";
import SectionHeader from "../components/SectionHeader";
import Joinvillage from "../components/landingpage/Joinvillage";
import { Link } from "react-router-dom";
import { Headline, Body } from "../components/brand";

const partners = [
  { name: "SOV", logo: "/images/partnerships/SOV.jpg", url: "https://www.specialolympics.com.au/" },
  { name: "Atalgo", logo: "/images/partnerships/atalgo.jpg", url: null },
  { name: "Best Chance", logo: "/images/partnerships/bestchance.jpg", url: "https://www.bestchance.org.au/" },
  { name: "Carevo", logo: "/images/partnerships/carevo.jpg", url: "https://carevo.com.au/" },
  { name: "Envaedha", logo: "/images/partnerships/envaedha.jpg", url: "https://envaedha.com.au" },
  { name: "Flourish", logo: "/images/partnerships/Flourish.jpg", url: "https://www.flourishaustralia.org.au/" },
  { name: "Social Threads", logo: "/images/partnerships/social-threads.jpg", url: "https://www.socialthreads.au/" },
  { name: "Soulful Learning", logo: "/images/partnerships/soulful-learning.jpg", url: "https://soulful-learning.com.au/" },
];

const PartnershipsPage = () => {
  return (
    <div className="w-full flex flex-col items-stretch gap-[56px] md:gap-[100px]">
      <div
        className="w-full flex flex-col items-start justify-center px-6 md:px-16 py-16 md:py-24 text-left"
        style={{ background: "var(--color-cloud-mist)" }}
      >
        <div className="max-w-[720px] flex flex-col items-start gap-5">
          <span className="text-[13px] md:text-[14px] font-semibold text-spectrum-blue tracking-widest uppercase">
            Our Partners
          </span>
          <Headline light="Building a better future," bold="together." as="h1" />
          <Body>
            We are proud to collaborate with organisations who share our passion
            for supporting individuals on the spectrum and their families.
          </Body>
        </div>
      </div>

      <div className="w-full px-6 md:px-16">
        <div className="max-w-[1280px] mx-auto flex flex-col gap-12 items-start">
          <SectionHeader
            title="Trusted Partners"
            light="Organisations we"
            bold="proudly work with."
            para="Each of our partners brings unique expertise and a shared commitment to creating a more inclusive world."
          />

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 w-full">
            {partners.map((partner) => {
              const card = (
                <div
                  className={`flex flex-col items-start justify-center gap-3 bg-white rounded-brand p-6 border border-cloud-mist transition-shadow duration-300 text-left ${
                    partner.url ? "hover:shadow-lg cursor-pointer" : ""
                  }`}
                  style={{ boxShadow: "0px 2px 12px rgba(0, 46, 169, 0.06)" }}
                >
                  <div className="w-full h-[100px] flex items-center justify-start">
                    <img
                      src={process.env.PUBLIC_URL + partner.logo}
                      alt={`${partner.name} logo`}
                      className="max-h-[80px] max-w-full object-contain"
                    />
                  </div>
                  <p className="text-[13px] font-semibold text-navy text-left">
                    {partner.name}
                  </p>
                </div>
              );
              return partner.url ? (
                <a
                  key={partner.name}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {card}
                </a>
              ) : (
                <div key={partner.name}>{card}</div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="w-full px-6 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div
            className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 rounded-brand px-8 md:px-16 py-12 text-left"
            style={{ background: "var(--color-cloud-mist)" }}
          >
            <div className="flex flex-col gap-3 text-left">
              <Headline light="Interested in" bold="partnering with us?" as="h2" />
              <Body>
                We&apos;re always looking to grow our network of like-minded
                organisations. Reach out and let&apos;s explore how we can work
                together.
              </Body>
            </div>
            <Link to="/contactus" className="btn-primary whitespace-nowrap">
              Get in Touch →
            </Link>
          </div>
        </div>
      </div>

      <Joinvillage />
    </div>
  );
};

export default PartnershipsPage;
